import React from 'react'
import Weather from './components/weather';

function App() {
  return (
    <div className='App'>
      <Weather />
    </div>
  );
}

export default App;
